import { Component } from 'react';
import { Box, Typography, Button, Alert } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useTranslation } from 'react-i18next';

function ErrorFallback() {
  const { t } = useTranslation();

  const handleRetry = () => {
    window.location.reload();
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '50vh',
        gap: 2,
        p: { xs: 2, sm: 3 },
        width: '100%',
      }}
    >
      <Alert
        severity="error"
        sx={{
          maxWidth: { xs: '100%', sm: 400 },
          width: '100%',
        }}
      >
        <Typography variant="body2">
          {t('common.pageLoadError')}
        </Typography>
      </Alert>
      <Button
        variant="contained"
        size="large"
        startIcon={<RefreshIcon />}
        onClick={handleRetry}
        sx={{
          minHeight: 48,
          minWidth: 120,
        }}
      >
        {t('common.retry')}
      </Button>
    </Box>
  );
}

class LazyLoadErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Lazy load error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <ErrorFallback />;
    }

    return this.props.children;
  }
}

export default LazyLoadErrorBoundary;
